<app-toolbar-button icon="menu-outline" (click)="toggleMenu()"></app-toolbar-button>
